import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const List = withSafeSuspense(lazy(
  async () => ({ default: (await import('./list')).List })
))
